import {
  _primaryControls,
  _increment,
  orderNumber,
  orderDate,
  type,
  vehicle,
  status,
  paymentType,
  customerName,
  /* eslint-disable-next-line */
  area_id,
  address,
  totalWeight,
  deliveryFee,
  remarks,
  lastUpdatedBy,
  updatedAt,
  sortable,
  createdAt,
} from './base';

export default {
  types: {
    _primaryControls,
    _increment,
    orderNumber,
    type,
    vehicle,
    createdAt,
    status,
    paymentType,
    customerName,
    /* eslint-disable-next-line */
    area_id,
    address,
    totalWeight,
    'packages.length': {
      name: 'จำนวนรายการ',
      width: '1fr',
      class: 'text-center',
    },
    deliveryFee,
    remarks,
    lastUpdatedBy,
    updatedAt,
  },
  sortable,
};
